module.exports = __webpack_public_path__ + "img/cake.bcc5271f.png";